import Vue from "vue";
import Vuex from "vuex";

import users from "./modules/users";
import theme from "./modules/theme";
import boards from "./modules/boards";
import lists from "./modules/lists";
import cards from "./modules/cards";
import files from "./modules/files";
import cardMessages from "./modules/cardMessages";
import fieldsInt from "./modules/fieldsInt";
import fieldsTxt from "./modules/fieldsTxt";
import events from "./modules/events";
import alarms from "./modules/alarms";
import botRiotLists from "./modules/botRiotLists";
import keyboard from "./modules/keyboard";

import cache from "@/store/cache.js";

import {
  SET_WINDOW_SIZE,
  SET_NO_ERROR,
  SWITCH_SHOW_HISTORY,
  EDIT_CARD,
  SWITCH_SHOW_ARCHIVE,
  EDIT_LIST,
  SET_CONFIRMATION_DIALOG,
  SWITCH_SHOW_MESSAGES
} from "./actions.type";
import urlManager from "@/common/urls";

Vue.use(Vuex);

const vue = new Vue();

//temp fix for smoothDnd
function removeSmoothDndClasses() {
  const classes = window.document.body.className
    .split(" ")
    .filter(p => p && p != "smooth-dnd-disable-touch-action" && p != "smooth-dnd-no-user-select");
  window.document.body.className = classes.join(" ");
  setTimeout(() => {
    const classes = window.document.body.className
      .split(" ")
      .filter(p => p && p != "smooth-dnd-disable-touch-action" && p != "smooth-dnd-no-user-select");
    window.document.body.className = classes.join(" ");
  }, 100);
}

document.addEventListener("touchend", removeSmoothDndClasses);

const store = new Vuex.Store({
  modules: {
    theme,
    users,
    boards,
    lists,
    cards,
    files,
    cardMessages,
    fieldsInt,
    fieldsTxt,
    events,
    alarms,
    keyboard,
    botRiotLists
  },
  state: {
    showHistory: false,
    showArchive: false,
    showMessages: false,
    window: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    dialogs: {
      confirmation: false
    },
    error: null,
    isConnected: false,
    drag: {
      card: false,
      list: false,
      board: false
    }
  },
  mutations: {
    SOCKET_EVENT_ERROR(state, data) {
      if (data.message) {
        state.error = data.message;
      } else {
        state.error = data;
      }
      console.error(data);
    },
    [SET_WINDOW_SIZE](state, window) {
      state.window.width = window.innerWidth;
      state.window.height = window.innerHeight;
    },
    [SET_NO_ERROR](state) {
      state.error = null;
    },
    [SWITCH_SHOW_HISTORY](state) {
      state.showHistory = !state.showHistory;
      state.showArchive = false;
      state.showMessages = false;
    },
    [SWITCH_SHOW_ARCHIVE](state) {
      state.showHistory = false;
      state.showArchive = !state.showArchive;
      state.showMessages = false;
    },
    [SWITCH_SHOW_MESSAGES](state) {
      state.showHistory = false;
      state.showArchive = false;
      state.showMessages = !state.showMessages;
    },
    [SET_CONFIRMATION_DIALOG](state, value) {
      state.dialogs.confirmation = !!value;
    },
    STOP_ANY_DRAG(state) {
      state.drag.card = false;
      state.drag.list = false;
      state.drag.board = false;

      vue.$eventHub.$emit("command-clear-card-selection");
    },
    DRAG_CARD(state, value) {
      state.drag.card = value;
      if (!value) {
        vue.$eventHub.$emit("command-clear-card-selection");
      }
    },
    DRAG_LIST(state, value) {
      state.drag.list = value;
    },
    DRAG_BOARD(state, value) {
      state.drag.board = value;
    }
  },
  actions: {
    async clear({ dispatch }) {
      await dispatch("alarms/clear");
      await dispatch("boards/clear");
      await dispatch("botRiotLists/clear");
      await dispatch("cardMessages/clear");
      await dispatch("cards/clear");
      await dispatch("events/clear");
      await dispatch("fieldsInt/clear");
      await dispatch("fieldsTxt/clear");
      await dispatch("files/clear");
      await dispatch("lists/clear");
      await dispatch("users/clear");

      cache.clear();
    },
    socket_connect({ state, dispatch }) {
      state.isConnected = true;
      dispatch("events/getNewEvents");
    },
    socket_disconnect({ state }) {
      state.isConnected = false;
    },
    [EDIT_CARD]({ state }, card) {
      if (!card) {
        console.error("EDIT_CARD null was passed instead of card");
        return;
      }

      let cardId = card.id;
      if (!cardId) {
        //id was passed
        cardId = card;
        card = cache.cards.byId(cardId);
      }

      if (card) {
        urlManager.toEditCard(card);
      } else {
        vue.$socket.emit("get_card", { id: cardId }, function(answer) {
          if (answer.error) {
            return;
          }

          urlManager.toEditCard(answer);
        });
      }
    },
    [EDIT_LIST]({ state }, list) {
      if (!list) {
        return;
      }

      let listId = list.id;
      if (!listId) {
        //id was passed
        listId = list;
        list = cache.lists.byId(listId);
      }

      if (list) {
        urlManager.toEditList(list);
      } else {
        vue.$socket.emit("get_list", { id: listId }, function(answer) {
          if (answer.error) {
            return;
          }

          urlManager.toEditList(answer);
        });
      }
    }
  },
  getters: {
    isMobileDevice(state) {
      return state.window.width < 800;
    },
    error(state) {
      return state.error;
    },
    showHistory(state) {
      return state.showHistory;
    },
    showArchive(state) {
      return state.showArchive;
    },
    isDraggingCard(state) {
      return state.drag.card;
    },
    isDragging(state) {
      return state.drag.card || state.drag.list || state.drag.board;
    },
    loaded(state) {
      return state.cards.loaded && state.fieldsTxt.loaded && state.fieldsInt.loaded;
    }
  }
});

cache.store = store;

export default store;
